// Default Meta Data
export const defaultMetaTitle = 'Custom Tours & Travel Services - KESARi Inbound';
export const defaultMetaDescription =
  'Explore tailored tours and travel packages with KESARi Inbound. Experience personalized travel solutions for your dream destinations.';
export const defaultMetaKeywords = [
  'custom tours',
  'travel services',
  'tailored travel',
  'personalized tours',
  'KESARi Select',
  'KESARi Inbound',
  'travel packages',
  'dream destinations',
  'client requirements'
];

export const getTopDestinationContinent = 'India'; // Add any continent and to get the resulte on /package-listing page

export const IndianZones = {
  West: [
    'Rajasthan',
    'Madhya Pradesh',
    'Gujarat',
    'Daman & Diu',
    'Dadra & Nagar Haveli',
    'Maharashtra',
    'Goa'
  ],
  South: [
    'Andhra Pradesh',
    'Karnataka',
    'Lakshadweep',
    'Kerala',
    'Tamil Nadu',
    'Pondicherry',
    'Telangana',
    'Andaman & Nicobar'
  ],
  North: [
    'Jammu & Kashmir',
    'Himachal Pradesh',
    'Punjab',
    'Chandigarh',
    'Uttarakhand',
    'Haryana',
    'Delhi',
    'Uttar Pradesh',
    'Leh & Ladakh'
  ],
  East: [
    'Bihar',
    'Sikkim',
    'Arunachal Pradesh',
    'Nagaland',
    'Manipur',
    'Mizoram',
    'Tripura',
    'Meghalaya',
    'Assam',
    'West Bengal',
    'Jharkhand',
    'Odisha',
    'Chhattisgarh',
    'North East'
  ]
};

// Find out zone using indian states
export const GetZoneUsingState = (state) => {
  const normalizeState = (str) =>
    str
      .toLowerCase()
      .replace(/\band\b/g, '&')
      .replace(/\bislands\b/g, '')
      .replace(/\s+/g, ' ')
      .trim();
  const normalizedState = normalizeState(state);
  let zone = '';
  for (const [key, states] of Object.entries(IndianZones)) {
    const normalizedStates = states.map(normalizeState);
    if (normalizedStates.includes(normalizedState)) {
      zone = `${key}-india`.toLowerCase().replace(/ & /g, '-').replace(/ /g, '-');
      break;
    }
  }
  return zone;
};

// Calculate Business counting
export const formatCount = (count, desc) => {
  const formatWithSuffix = (number, suffix) => {
    if (suffix === 'B') {
      const formatted = number.toFixed(2);
      if (formatted.endsWith('0')) {
        return number.toFixed(1) + suffix;
      }
      return formatted + suffix;
    }
    return Math.floor(number) + suffix;
  };

  if (
    desc === 'Years Of Legacy' ||
    desc === 'Skilled Team' ||
    desc === 'Satisfied Guests' ||
    desc === 'Tour Options'
  ) {
    if (count >= 1000000000) {
      return formatWithSuffix(count / 1000000000, 'B') + '+';
    } else if (count >= 1000000) {
      return formatWithSuffix(count / 1000000, 'M') + '+';
    } else if (count >= 1000) {
      return formatWithSuffix(count / 1000, 'K') + '+';
    }
  } else if (desc === 'Repeat Customers' || desc === 'Repeat Travellers') {
    return count + '%';
  }
  return count + '+';
};

export const convertToHyphenatedLowerCase = (str) => {
  if (typeof str !== 'string') {
    return '';
  }
  return str.toLowerCase().replace(/&/g, '-and-').replace(/\s+/g, '-');
};

// Convert Array to Array of Objects
export const convertArrayToObjectArray = (array) =>
  array.map((item) => ({ label: item, value: item }));

export const capitalizeFirstLetterWithAnd = (string) => {
  if (!string) return '';
  return string
    .toLowerCase()
    .replace(/-/g, ' ')
    .split(' ')
    .map((word) => (word === 'and' ? word : word.charAt(0).toUpperCase() + word.slice(1)))
    .join(' ');
};

// Convert Theme data from path segments
export const formatThemePathSegmentsString = (input) => {
  const formatted = input?.replace(/-and-/g, ' and ').replace(/-/g, ' ').toLowerCase();
  const capitalized = formatted?.replace(/\b\w+/g, (word) =>
    word === 'and' ? 'and' : word.charAt(0).toUpperCase() + word.slice(1)
  );
  return capitalized;
};

export const ConvertToRegionName = (hyphenatedString) => {
  const [region] = hyphenatedString.split('-');
  return region.charAt(0).toUpperCase() + region.slice(1);
};

//Check continent last character
export const formatContinentName = (continentName) => {
  if (continentName.endsWith('a')) {
    return continentName + 'n';
  } else {
    return continentName + 'an';
  }
};

// Function to convert selectedBudgets from strings to numbers
export const ConvertSelectedBudgetsToNumbers = (selectedBudgets) => {
  const numericBudgets = [];
  selectedBudgets.forEach((range) => {
    let min = 0,
      max = Infinity;
    const cleanedRange = String(range)
      .replace(/[^\d.,-]/g, '')
      .split('-')
      .map((val) => {
        val = val.replace(/^\.*/, '');
        if (val.includes(',')) {
          return parseFloat(val.replace(/,/g, ''));
        } else {
          return parseFloat(val) * 100000;
        }
      });

    if (cleanedRange.length === 1) {
      if (range.includes('Below')) {
        max = cleanedRange[0];
      } else if (range.includes('Above')) {
        min = cleanedRange[0];
      }
    } else if (cleanedRange.length === 2) {
      [min, max] =
        cleanedRange[0] > cleanedRange[1] ? [cleanedRange[1], cleanedRange[0]] : cleanedRange;
    }
    numericBudgets.push({ min, max });
  });
  return numericBudgets;
};

// Use url string after .com or any domain
export const getUrlAfterDomain = (url) => {
  const domainIndex = url.indexOf('.com');
  if (domainIndex !== -1) {
    return url.substring(domainIndex + 4);
  }
  return url;
};

// Convert selected theme as per dynamic url requirement
export const convertCommaToAnd = (input) =>
  input
    .split(',')
    .map((part) => part.trim().replace(/\s+/g, '-').toLowerCase())
    .join('-and-');
